// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__gnN3X","unreadBadge":"styles_unreadBadge__60FNT","modalContent":"styles_modalContent__ShHXU","modal":"styles_modal__1QiUh"};